import { getChildren, getChildrenByTypeDeep, getChildrenDeep } from 'react-nanny';

import React from 'react';

const InstrumentContent = ( { children, ...props }) => {
  const instrument = props.instrument;
  let elements = new Array();
  elements = getChildrenByTypeDeep(children, [instrument]);
  if(elements.length<1){
    elements = getChildrenDeep(children, child => child.props?.default || child.type === 'default');
  }
  return (
    <>
    {elements.map((element) => 
      <div key="score">{element.props.children}</div>
    )}
    </>
  );
}


export default InstrumentContent;